export const FETCH_ACCOUNT_DETAILS_TYPE = 'FETCH_ACCOUNT_DETAILS';
export const FETCH_ACCOUNT_DETAILS_PENDING = `${FETCH_ACCOUNT_DETAILS_TYPE}_PENDING`;
export const FETCH_ACCOUNT_DETAILS_FULFILLED = `${FETCH_ACCOUNT_DETAILS_TYPE}_FULFILLED`;
export const FETCH_ACCOUNT_DETAILS_REJECTED = `${FETCH_ACCOUNT_DETAILS_TYPE}_REJECTED`;
export const SYNCHRONIZE_WISHLIST_TYPE = 'SYNCHRONIZE_WISHLIST';
export const SYNCHRONIZE_WISHLIST_PENDING = `${SYNCHRONIZE_WISHLIST_TYPE}_PENDING`;
export const SYNCHRONIZE_WISHLIST_FULFILLED = `${SYNCHRONIZE_WISHLIST_TYPE}_FULFILLED`;
export const SYNCHRONIZE_WISHLIST_REJECTED = `${SYNCHRONIZE_WISHLIST_TYPE}_REJECTED`;

export const fetchAccountDetailsActionCreator = promise => ({
  type: FETCH_ACCOUNT_DETAILS_TYPE,
  payload: promise,
});

export const synchronizeWishlistActionCreator = promise => ({
  type: SYNCHRONIZE_WISHLIST_TYPE,
  payload: promise,
});
